import api from './api';

const BASE = '/fotos';

export const fotosService = {
    listar: async (modulo, itemId, sesion, ct = null) => {
        const response = await api.get(`${BASE}/`, {
            params: { modulo, item_id: itemId, sesion, ct: ct || undefined },
        });
        return response.data;
    },

    subir: async (file, { modulo, itemId, sesion, ct = null }) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${BASE}/subir`, formData, {
            params: { modulo, item_id: itemId, sesion, ct: ct || undefined },
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    eliminar: async (fotoId) => {
        const response = await api.delete(`${BASE}/${fotoId}`);
        return response.data;
    },

    listarPorSolicitud: async (solicitudId) => {
        const response = await api.get(`${BASE}/por-solicitud/${solicitudId}`);
        return response.data;
    },
};
